let firstExpose = true;
let canSet = false;

const globalName = 'gozer';
const devGlobals = new Proxy(
    {},
    {
        get(target, key) {
            return target[key];
        },
        set(target, key, value) {
            if (canSet) {
                target[key] = value;
            }
            return true;
        },
        deleteProperty() {
            return true;
        },
    },
);

const expose = (name, value) => {
    if (firstExpose) {
        window[globalName] = devGlobals;
        firstExpose = false;
    }
    canSet = true;
    devGlobals[name] = value;
    canSet = false;
};

export default expose;
